import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

import InputMask from 'react-input-mask';
import Select from 'react-select';

class SchedulePeriodDuplicate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      period: {},
      date_start: null,
      date_finish: null,
      type: null,
    };

    this.add = this.add.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  // LM
  componentWillReceiveProps(newProps) {
    if((this.state.loaded === 0 && typeof newProps.period.name !== 'undefined') || (this.state.loaded === 1 && newProps.updated === 1)) {
      this.setState({
        period: newProps.period,
        loaded: 1,
      });
    }
  }

    // Fetch salvando a edição
  add(event) {
    event.preventDefault();
    this.props.addPeriod(this.state.period.id, this.state.date_start, this.state.date_finish, this.state.type);
  }

  render() {
    var self = this;
    return (
<div>
  <form onSubmit={this.add}>
    <div className="row">
      <div className="col-md-4 form-group">
        <label>Data inicial:</label>
        <InputMask maskChar={null} mask="99/99/9999" type="text" className="form-control" name="date_start" value={this.state.date_start} onChange={this.handleChange.bind(this, 'date_start')} required />
      </div>
      <div className="col-md-4 form-group">
        <label>Data final:</label>
        <InputMask maskChar={null} mask="99/99/9999" type="text" className="form-control" name="date_finish" value={this.state.date_finish} onChange={this.handleChange.bind(this, 'date_finish')} required />
      </div>
      <div className="col-md-4 form-group">
        <label>Tipo:</label>
        <Select
          className="form-field-name"
          name="type"
          value={this.state.type}
          searchable={true}
          placeholder={''}
          onChange={this.handleSelectChange.bind(this, 'type')}
          options={[
            {value: 'MIS', label: 'MIS'},
            {value: 'FR', label: 'FR'},
            {value: 'MIS-A', label: 'MIS-A'},
            {value: "TROCA", label: "TROCA"},
          ]}
          required
        />
      </div>
    </div>
    <button type={'submit'} className="btn btn-primary btn-block"><i className="fa fa-fw fa-save"></i> Adicionar datas ao período</button>
  </form>
</div>
    );
  }
}

export default SchedulePeriodDuplicate;



// WEBPACK FOOTER //
// ./src/Components/Schedules/Elements/SchedulePeriodDuplicate.js